import { render } from "./pagoWebError.vue?vue&type=template&id=7f31553e"
import script from "./pagoWebError.vue?vue&type=script&lang=js"
export * from "./pagoWebError.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\btobia\\Documents\\ProyectosVSC\\marketvue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__